import { NSARouterMakerProps } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';
import { NamirasoftMap } from 'namirasoft-site-map';

interface ITopicListPageIProps extends NSARouterMakerProps, NotificationSenderProps
{ }

function TopicListPage(props: ITopicListPageIProps) 
{
    let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

    return (
        <NotificationSenderLayout {...props}
            pages={{
                entity: NotificationSenderEntity.Topic(props),
                list: {
                    ui: {
                        search_box: {
                            exclude: {
                                load_value: (table, column) =>
                                {
                                    if (namirasoft.notification_sender.tables.sent_topic.name === table)
                                    {
                                        let columns = [
                                            namirasoft.notification_sender.tables.sent_topic.columns.message.name,
                                        ]
                                        return columns.includes(column);
                                    }
                                    return false;
                                }
                            }
                        }
                    }
                }
            }}
        >
            <></>
        </NotificationSenderLayout >
    );
}

export default TopicListPage;